import React from "react";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { TICKET_CANNED_RESPONSE_SEND_PERMISSION } from "components/dashboard/AgentInbox/permissions";
import "./TicketCannedResponse.scss";

const TicketCannedResponse = ({ response, title, setCannedMessage }) => {
    return (
        <ComponentAccessControl
            baseResources={TICKET_CANNED_RESPONSE_SEND_PERMISSION}>
            <div
                className={"ticket-canned-response"}
                onClick={() => setCannedMessage(response)}>
                <span>{title}</span>
            </div>
        </ComponentAccessControl>
    );
};

export default TicketCannedResponse;
